import Swiper from "swiper/swiper-bundle.mjs";

const carousel = new Swiper(".carousel", {
  freeMode: true,
  slidesPerView: 1.25,
  slidesOffsetAfter: 12,
  slidesOffsetBefore: 12,
  mousewheel: {
    enabled: true,
    forceToAxis: true,
  },
  spaceBetween: "24",
  breakpoints: {
    640: {
      slidesPerView: 1.5,
      slidesOffsetAfter: 24,
      slidesOffsetBefore: 24,
    },
    768: {
      slidesPerView: 2.5,
      slidesOffsetAfter: 48,
      slidesOffsetBefore: 48,
    },
  },
});

const teamCarousel = new Swiper(".team-carousel", {
  freeMode: true,
  slidesPerView: 2.25,
  slidesOffsetAfter: 12,
  slidesOffsetBefore: 12,
  mousewheel: {
    enabled: true,
    forceToAxis: true,
  },
  spaceBetween: "24",
  breakpoints: {
    640: {
      slidesPerView: 3.5,
      slidesOffsetAfter: 24,
      slidesOffsetBefore: 24,
    },
    768: {
      slidesPerView: 4.5,
      slidesOffsetAfter: 48,
      slidesOffsetBefore: 48,
    },
  },
});
